import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';

export const SavedTabValidator = arkScope.type({
  id: 'string',
  tabName: 'string',
  tabType: "'tiles' | 'bulkTrade' | 'bulkOrder'",
  clientId: 'number',
});
